import { render, staticRenderFns } from "./CostoServicio.vue?vue&type=template&id=4a3b6940&scoped=true"
import script from "./CostoServicio.vue?vue&type=script&lang=js"
export * from "./CostoServicio.vue?vue&type=script&lang=js"
import style0 from "./CostoServicio.vue?vue&type=style&index=0&id=4a3b6940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b6940",
  null
  
)

export default component.exports